import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Label } from "reactstrap";
import { getAll } from "../../../../../localDB";

const EvaluationFieldwork = ({
    account,
    session,
    setMaxSubPage,
    setSubPageInComplete,
    answerFactor,
    setAnswerFactor,
    setValidationMessage
}) => {

    const [client, setClient] = useState([]);

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
        }); // e.g., April 1, 2025
    };

    const fetchData = async () => {
        try {
            const c = await getAll("Client");
            setClient(c);
        } catch (error) {

        }
    }

    // Notify parent that this step has only one subpage (index 0)
    useEffect(() => {
        setMaxSubPage(0);
        setSubPageInComplete(false);
        fetchData();
    }, [setMaxSubPage]);

    return (
        <div className="evaluation-fieldwork h-100 d-flex flex-column">
            <div className="label-row">
                <div>
                    <Label className="label-title">AGENT NAME:</Label>
                    <Label>{account?.Name}</Label>
                </div>
                <div>
                    <Label className="label-title">DATE:</Label>
                    <Label>{formatDate(session?.SessionDate)?.toUpperCase()}</Label>
                </div>
            </div>

            <div className="label-row">
                <div className="d-flex align-items-center">
                    <Label className="label-title">CLIENT NAME:</Label>
                    <Dropdown>
                        <Dropdown.Toggle className="form-control text-start">
                            {answerFactor?.client?.Name || "-- Select Client --"}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="w-100">
                            {client.map(c => (
                                <Dropdown.Item
                                    key={c.ID}
                                    onClick={() =>
                                        setAnswerFactor(prev => ({
                                            ...prev,
                                            client: c
                                        }))
                                    }
                                >
                                    <span>{c.Name}</span>
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>

            <div className="d-flex align-items-center justify-content-center h-100">
                <div className="text-center w-75">This evaluation presents a summary of performance based on key criteria observed during the assessment period.</div>
            </div>
        </div>
    )
}

export default EvaluationFieldwork